import { render, staticRenderFns } from "./Uploads.vue?vue&type=template&id=e298692a&scoped=true&"
import script from "./Uploads.vue?vue&type=script&lang=tsx&"
export * from "./Uploads.vue?vue&type=script&lang=tsx&"
import style0 from "./Uploads.vue?vue&type=style&index=0&id=e298692a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e298692a",
  null
  
)

export default component.exports